import { render } from "./Cocina.vue?vue&type=template&id=2072e5eb"
import script from "./Cocina.vue?vue&type=script&lang=js"
export * from "./Cocina.vue?vue&type=script&lang=js"
script.render = render

export default script